module.exports = __webpack_public_path__ + "static/media/Quarter_C.6168a4e2.png";